import { Component, Fragment, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import Pagination from "../component/sidebar/pagination";
import PopularPost from "../component/sidebar/popular-post";
import Rating from "../component/sidebar/rating";
import Search from "../component/sidebar/search";
import ShopCategory from "../component/sidebar/shop-category";
import Tags from "../component/sidebar/tags";

import shopImg01 from "assets/images/shop/01.jpg";
import shopImg02 from "assets/images/shop/02.jpg";
import shopImg03 from "assets/images/shop/03.jpg";
import shopImg04 from "assets/images/shop/04.jpg";
import shopImg05 from "assets/images/shop/05.jpg";
import shopImg06 from "assets/images/shop/06.jpg";
import shopImg07 from "assets/images/shop/07.jpg";
import shopImg08 from "assets/images/shop/08.jpg";
import shopImg09 from "assets/images/shop/09.jpg";

const showResult = "Showing 01 - 12 of 139 Results";

let ProductList = [
	{
		imgUrl: shopImg01,
		imgAlt: "Product Thumb",
		title: "Product Title Here",
		price: "$200.00",
		desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo"
	},
	{
		imgUrl: shopImg02,
		imgAlt: "Product Thumb",
		title: "Product Title Here",
		price: "$200.00",
		desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo"
	},
	{
		imgUrl: shopImg03,
		imgAlt: "Product Thumb",
		title: "Product Title Here",
		price: "$200.00",
		desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo"
	},
	{
		imgUrl: shopImg04,
		imgAlt: "Product Thumb",
		title: "Product Title Here",
		price: "$200.00",
		desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo"
	},
	{
		imgUrl: shopImg05,
		imgAlt: "Product Thumb",
		title: "Product Title Here",
		price: "$200.00",
		desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo"
	},
	{
		imgUrl: shopImg06,
		imgAlt: "Product Thumb",
		title: "Product Title Here",
		price: "$200.00",
		desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo"
	},
	{
		imgUrl: shopImg07,
		imgAlt: "Product Thumb",
		title: "Product Title Here",
		price: "$200.00",
		desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo"
	},
	{
		imgUrl: shopImg08,
		imgAlt: "Product Thumb",
		title: "Product Title Here",
		price: "$200.00",
		desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo"
	},
	{
		imgUrl: shopImg09,
		imgAlt: "Product Thumb",
		title: "Product Title Here",
		price: "$200.00",
		desc: "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo"
	}
];

const ShopPage = () => {
	const [GridList, setGridList] = useState(true);

	return (
		<Fragment>
			<Header />
			<PageHeader title={"Our Shop Pages"} curPage={"Shop"} />
			<div className="shop-page padding-tb">
				<div className="container">
					<div className="row justify-content-center">
						<div className="col-lg-8 col-12">
							<article>
								<div className="shop-title d-flex flex-wrap justify-content-between">
									<p>{showResult}</p>
									<div className={`product-view-mode ${GridList ? "gridActive" : "listActive"}`}>
										<a className="grid" onClick={() => setGridList(!GridList)}>
											<i className="icofont-ghost"></i>
										</a>
										<a className="list" onClick={() => setGridList(!GridList)}>
											<i className="icofont-listine-dots"></i>
										</a>
									</div>
								</div>
								<div
									className={`shop-product-wrap row justify-content-center ${
										GridList ? "grid" : "list"
									}`}>
									{ProductList.map((val, i) => (
										<div className="col-lg-4 col-md-6 col-12" key={i}>
											<div className="product-item">
												<div className="product-thumb">
													<div className="pro-thumb">
														<img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
													</div>
													<div className="product-action-link">
														<a href="#">
															<i className="icofont-eye"></i>
														</a>
														<a href="#">
															<i className="icofont-heart"></i>
														</a>
														<a href="#">
															<i className="icofont-cart-alt"></i>
														</a>
													</div>
												</div>
												<div className="product-content">
													<h5>
														<Link to="/shop-single">{val.title}</Link>
													</h5>
													<p className="productRating">
														<Rating />
													</p>
													<h6>{val.price}</h6>
												</div>
											</div>
											<div className="product-list-item">
												<div className="product-thumb">
													<div className="pro-thumb">
														<img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
													</div>
													<div className="product-action-link">
														<a href="#">
															<i className="icofont-eye"></i>
														</a>
														<a href="#">
															<i className="icofont-heart"></i>
														</a>
														<a href="#">
															<i className="icofont-cart-alt"></i>
														</a>
													</div>
												</div>
												<div className="product-content">
													<h5>
														<Link to="/shop-single">{val.title}</Link>
													</h5>
													<p className="productRating">
														<Rating />
													</p>
													<h6>{val.price}</h6>
													<p>{val.desc}</p>
												</div>
											</div>
										</div>
									))}
								</div>
								<Pagination />
							</article>
						</div>
						<div className="col-lg-4 col-12">
							<aside>
								<Search />
								<ShopCategory />
								<PopularPost />
								<Tags />
							</aside>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</Fragment>
	);
};

export default ShopPage;
